export default "__VITE_ASSET__7cdcbcd1__"